import gql from "graphql-tag";

export const CREATE_UPDATE_SERVICE_PROVIDER = gql`
mutation upsertServiceProvider($serviceProvider:[ServiceProviders_insert_input!]!, $updateColumns: [ServiceProviders_update_column!]!) {
  insert_ServiceProviders(objects: $serviceProvider, on_conflict: {constraint: ServiceProviders_pkey, update_columns: $updateColumns}){
    returning{id}
  }
}`

export const DELETE_SERVICE_PROVIDER_BY_ID = gql`
mutation deleteServiceProviderById($id:uuid!){
  delete_ServiceProviders(where:{id:{_eq:$id}}){
  returning{id}
  }
}`